<script>
  export let data = { lists: [] },
    contact;

  const lists = data.lists || [];
</script>

<ul>
  {#each lists as list}
    {#if list}
      <li><b>{list.name}</b></li>
    {/if}
  {/each}
</ul>
